import { ref, watch } from '@vue/composition-api';
import debounce from 'lodash.debounce';
import { changesDigitalData } from '@/utils/digitalData';

const useCampaigns = () => {
  const listCampaigns = ref([]);

  const changeCampaigns = (list) => {
    changesDigitalData(['campaigns', [
      ...(window?.digitalData?.campaigns || []),
      ...list,
    ], 'book24']);
  };

  const addCampaignsDebounce = debounce(changeCampaigns, 500);

  watch(
    () => listCampaigns.value,
    value => addCampaignsDebounce(value),
    { immediate: false },
  );

  const addCampaigns = (list) => {
    listCampaigns.value = [
      ...listCampaigns.value,
      ...list,
    ];
  };

  return { addCampaigns };
};

export default useCampaigns;
